import { basename } from 'path';

/**
 * Detect which binary name was used to invoke the CLI.
 * Returns 'jai1' if invoked as 'jai1', otherwise defaults to 'j'.
 */
export function getCliName(): string {
    const bin = basename(process.argv[1] || '');
    return bin === 'jai1' ? 'jai1' : 'j';
}
